var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main__sort"},[_c('i',{staticClass:"i i-filter",on:{"click":_vm.toggle}}),_vm._v(" "),_c('div',{staticClass:"sort",class:{'sort--active': _vm.isActive}},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }